export default __webpack_public_path__ + "5a1c0992b35efbf96a835b9b072c79ca.svg";